import React, { lazy, Suspense } from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
} from "react-router-dom";
import checkAuth from "../../src/app/auth";
import AdminLayout from "../layouts/AdminLayout";
import Coupons from "../components/pages/Coupons";
import AddCoupons from "../components/pages/AddCoupons";
import User from "../components/pages/user/User";
import AddUser from "../components/pages/user/AddUser";
import Transaction from "../components/pages/transaction/Transaction";
import Booking from "../components/pages/transaction/Booking";
import BookingDetail from "../components/pages/transaction/BookingDetail";
import Configuration from "../components/pages/configurations/Configuration";
import AddConfiguration from "../components/pages/configurations/AddConfiguration";
import TourAndPackages from "../components/package/TourAndPackages";
import PackageList from "../components/package/PackageList";
import ManageAirportDestinationsList from "../components/airportDestinations/ManageAirportDestinationsList";
import AddManageAirportDestinations from "../components/airportDestinations/AddManageAirportDestinations";
import PopularAirPortDestination from "../components/airportDestinations/PopularAirPortDestination";
import AddPopularAirPortDestination from "../components/airportDestinations/AddPopularAirPortDestination";
import CategoryList from "../components/package/CategoryList";
import AddCategory from "../components/package/AddCategory";
import Adddestination from "../components/package/Adddestination";
import DestinationsList from "../components/package/DestinationsList";
import EnquiryList from "../components/pages/configurations/EnquiryList";
import HotelBooking from "../layouts/HotelBooking";
import HolidayBookings from "../layouts/HolidayBookings";
import FlightBookings from "../components/pages/transaction/Booking";
import PriceList from "../components/pages/PriceList";
import HotelBookings from "../layouts/HotelBooking";
import BookingHotelDetail from "../components/pages/transaction/BookingHotelDetail";
import HotelPriceList from "../components/pages/HotelPriceList";
import ConvenienceFeesAndChargesList from "../components/conveniencefeesCharges/ConvenienceFeesAndCharges";
import AddConvenienceFeesAndCharges from "../components/conveniencefeesCharges/AddConvenienceFeesAndCharges";
import PriceFareRuleList from "../components/pricefarerule/PriceFareRuleList";
import AddPriceFareRuleList from "../components/pricefarerule/AddPriceFareRuleList";
import SupportLayout from "../layouts/SupportLayout";
import Traveller from "../components/pages/user/Traveller";
import AddTraveller from "../components/pages/user/AddTraveller";
import Feedbacks from "../components/package/Feedbacks";
import AddFeedback from "../components/package/AddFeedback";

const Dashboard = lazy(() => import("../layouts/Dashboard"));

function SupportRouter() {
    const isAuthenticated = checkAuth();
    // popular-airPort-destination
    return (
        <Router>
            <Routes>
                <Route element={<SupportLayout />}>
                    {/* <Route path="/dashboard" element={<Dashboard />} /> */}

                    <Route path="/flight-bookings" element={<FlightBookings />} />
                    <Route path="/booking-detail/:id" element={<BookingDetail />} />
                    <Route path="/hotel-booking-details/:id" element={<BookingHotelDetail />} />

                    <Route path="/add-tour-and-packages" element={<TourAndPackages />} />
                    <Route path="/manage-airport-destinations-list" element={<ManageAirportDestinationsList />} />
                    <Route path="/add-manage-airport-destinations" element={<AddManageAirportDestinations />} />
                    <Route path="/edit-manage-airport-destinations/:id" element={<AddManageAirportDestinations />} />
                    <Route path="/edit-package/:id" element={<TourAndPackages />} />
                    <Route path="/package-list" element={<PackageList />} />
                    <Route path="/category-list" element={<CategoryList />} />
                    <Route path="/add-category" element={<AddCategory />} />
                    <Route path="/edit-category/:id" element={<AddCategory />} />

                    <Route path="/destination-list" element={<DestinationsList />} />
                    <Route path="/add-destination" element={<Adddestination />} />
                    <Route path="/edit-destination/:id" element={<Adddestination />} />

                    <Route path="/hotel-bookings" element={<HotelBookings />} />
                    <Route path="/holiday-bookings" element={<HolidayBookings />} />

                    <Route path="/guest-list" element={<Traveller />} />
                    <Route path="/edit/:id" element={<AddTraveller />} />
                    <Route path="/add-feedback" element={<AddFeedback />} />
                    <Route path="/edit-feedback/:id" element={<AddFeedback />} />
                    <Route path="/feedbacks" element={<Feedbacks />} />


                    <Route path="*" element={<Navigate to="/flight-bookings" replace />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default SupportRouter;
